"use client";

export {
  createOtpAuthProvider,
  type CreateOtpAuthProviderOptions,
  type OtpAuthNotify,
} from "./createOtpAuthProvider";
